package com.shadowings.gero.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.Message
import com.shadowings.gero.domain.repository.UserDataRepository
import com.shadowings.gero.presentation.model.IntroEffect
import com.shadowings.gero.presentation.model.IntroUiState
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.intro_msg_1
import gero.composeapp.generated.resources.intro_msg_10
import gero.composeapp.generated.resources.intro_msg_14
import gero.composeapp.generated.resources.intro_msg_17
import gero.composeapp.generated.resources.intro_msg_18
import gero.composeapp.generated.resources.intro_msg_19
import gero.composeapp.generated.resources.intro_msg_2
import gero.composeapp.generated.resources.intro_msg_20
import gero.composeapp.generated.resources.intro_msg_21
import gero.composeapp.generated.resources.intro_msg_22
import gero.composeapp.generated.resources.intro_msg_23
import gero.composeapp.generated.resources.intro_msg_3
import gero.composeapp.generated.resources.intro_msg_4
import gero.composeapp.generated.resources.intro_msg_5
import gero.composeapp.generated.resources.intro_msg_6
import gero.composeapp.generated.resources.intro_msg_7
import gero.composeapp.generated.resources.intro_msg_8
import gero.composeapp.generated.resources.intro_msg_9
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.channels.Channel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.receiveAsFlow
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.getString

import com.shadowings.gero.domain.repository.AnalyticsRepository

class IntroViewModel(
    private val userDataRepository: UserDataRepository,
    private val analyticsRepository: AnalyticsRepository,
) : ViewModel() {

    private val _currentMessageIndex = MutableStateFlow(0)
    private val _messages = MutableStateFlow<List<Message>>(emptyList())

    private val _effects = Channel<IntroEffect>(Channel.BUFFERED)
    val effects = _effects.receiveAsFlow()

    val uiState: StateFlow<IntroUiState> = combine(
        userDataRepository.userData,
        _messages,
        _currentMessageIndex
    ) { userData, messages, index ->
        IntroUiState(userData, messages, index)
    }.stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), IntroUiState())

    init {
        loadMessages()
        analyticsRepository.logTutorialStarted()
    }

    private fun loadMessages() {
        viewModelScope.launch(Dispatchers.Default) {
            val msgs = listOf(
                Message(Characters.Alyn, Faces.Surprised, getString(Res.string.intro_msg_1)),
                Message(Characters.Alyn, Faces.Idle, getString(Res.string.intro_msg_2)),
                Message(Characters.Alyn, Faces.Idle, getString(Res.string.intro_msg_3)),
                Message(Characters.Alyn, Faces.Happy, getString(Res.string.intro_msg_4)),
                Message(Characters.Alyn, Faces.Sad, getString(Res.string.intro_msg_5)),
                Message(Characters.Alyn, Faces.Serious, getString(Res.string.intro_msg_6)),
                Message(Characters.Nilo, Faces.Idle, getString(Res.string.intro_msg_7)),
                Message(Characters.Alyn, Faces.Happy, getString(Res.string.intro_msg_8)),
                Message(Characters.Alyn, Faces.Happy, getString(Res.string.intro_msg_9)),
                Message(Characters.Alyn, Faces.Idle, getString(Res.string.intro_msg_10)),
                Message(Characters.Alyn, Faces.Idle, getString(Res.string.intro_msg_14)),
                Message(Characters.Alyn, Faces.Happy, getString(Res.string.intro_msg_17)),
                Message(Characters.Alyn, Faces.Serious, getString(Res.string.intro_msg_18)),
                Message(Characters.Alyn, Faces.Perfect, getString(Res.string.intro_msg_19)),
                Message(Characters.Nilo, Faces.Idle, getString(Res.string.intro_msg_20)),
                Message(Characters.Alyn, Faces.Idle, getString(Res.string.intro_msg_21)),
                Message(Characters.Alyn, Faces.Happy, getString(Res.string.intro_msg_22)),
                Message(Characters.Alyn, Faces.Perfect, getString(Res.string.intro_msg_23)),
            )
            _messages.value = msgs
        }
    }

    fun onNextClicked() {
        val currentIndex = _currentMessageIndex.value
        val messagesCount = _messages.value.size

        if (currentIndex >= messagesCount - 1) {
            completeTutorial()
        } else {
            _currentMessageIndex.value = currentIndex + 1
            viewModelScope.launch {
                _effects.send(IntroEffect.ScrollToBottom)
            }
        }
    }

    fun completeTutorial() {
        viewModelScope.launch(Dispatchers.Default) {
            userDataRepository.setTutorialCompleted()
            analyticsRepository.logTutorialCompleted()
            _effects.send(IntroEffect.NavigateToMain)
        }
    }
}

